import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, EventEmitter, Output, TemplateRef, OnInit, Input, inject } from '@angular/core';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { apiService } from 'app/services/api.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { OriginDestinations, Travellers } from '@core/interfaces/flight';
import { CustomModalComponent } from '@shared/custom-modal/custom-modal.component';
import { FormGroup, FormBuilder, FormControl, FormArray, Validators, AbstractControl } from '@angular/forms';
import { globalData } from "app/services/globalData.service";
import { HTTP_INTERCEPTORS, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { TitleCasePipe } from '@angular/common';
import { customerService } from '../../../services/customer.service';
import { MyProfileInterceptor } from '@modules/myProfile/my-profile.interceptor';

interface Traveler {
  id: number;
  name: string;
  collapsed: boolean;
  selectedSavedTraveler: SavedTraveler | null;
  showPrice: boolean;
  addFrequentFlyer: boolean;
  addMealsAssistance: boolean;
  isCollapsed: boolean;
  isTravelerCollapsed: boolean;
}

export interface TravelerDetails {
  total: string;
  fare: string;
  taxes: string;
}

interface SavedTraveler {
  id: number;
  firstname: string;
  lastname: string;
  dob: string;
  nationality: string;
  passport: string;
  expiry: string;
  issueCountry: string;
  // Add more properties as needed for the form fields
}

@Component({
  selector: 'app-flight-booking-detail',
  templateUrl: './flight-booking-detail.component.html',
  styleUrls: ['./flight-booking-detail.component.scss'],
  providers: [
    TitleCasePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MyProfileInterceptor,
      multi: true,
    }
  ]
})
export class FlightBookingDetailComponent implements OnInit {

  showFlightSeatBooking = false;

  @Output() close = new EventEmitter<void>();
  @Input() selectedFlight: any;

  @Input() oneWaySummary: any;
  @Input() roundTripSummary: any;
  @Input() multiCitySummary: any;

  requestParams: any;

  bsConfig: object;
  travelers: (Traveler & TravelerDetails)[] = [
    { id: 1, name: 'Traveler 1 (Adult)', collapsed: false, selectedSavedTraveler: null, showPrice: false, total: 'SAR 172', fare: 'SAR 145', taxes: 'SAR 27', addFrequentFlyer: false, addMealsAssistance: false, isTravelerCollapsed: false, isCollapsed: false },
    { id: 2, name: 'Traveler 2 (Adult)', collapsed: true, selectedSavedTraveler: null, showPrice: false, total: 'SAR 172', fare: 'SAR 145', taxes: 'SAR 27', addFrequentFlyer: false, addMealsAssistance: false, isTravelerCollapsed: false, isCollapsed: false },
    // Add more travelers as needed
  ];


  displayCurrency = localStorage.getItem('displayCurrency');
  languageCode = localStorage.getItem('languageCode');
  flightOfferDetail: any;
  flightOfferPriceDetail: any;
  flightPriceByTraveller: any;

  searchRequestType: string;

  departureDate = new Date();
  returnDate = new Date();

  fromLocation: any;
  toLocation: any;

  @Input() layoverData: any;

  minDate: Date;
  maxDate: Date;

  submitted: boolean = false;
  flightTraveler: FormGroup;
  travellersData: any[] = [];

  CustomerLoggedIn: boolean = false;
  showFlightPayment: boolean = false;
  showFirstPop = true;
  showFlightBookingDetail: boolean = false;
  form: any;

  customerAuthExpire: boolean = false;
  customerTraveler: any = [];
  modalRef?: BsModalRef;
  // config = {
  //   backdrop: true,
  //   ignoreBackdropClick: true,
  //   class: 'gray modal-lg'
  //   // Object.assign({}, {  })
  // };

  config = {
    backdrop: true,
    ignoreBackdropClick: true,
    class: "my-login-modal modal-dialog-centered",
  };

  countryCodes: any[] = [];
  countryCodesNationality: any[] = [];

  constructor(private _apiService: apiService,
    private _customerService: customerService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    public activatedRoute: ActivatedRoute,
    public global: globalData,
    public TitleCasePipe: TitleCasePipe) {
    this.minDate = new Date();
  }

  ngOnInit(): void {
    //get route value
    this.createTravelerForm();
    this.activatedRoute.queryParamMap.subscribe((params: any) => {
      this.requestParams = { ...params.keys, ...params };
    });

    this.searchRequestType = this.requestParams.params.searchType;
    var copySelected = this.selectedFlight;
    let pricingArray = JSON.parse(JSON.stringify(copySelected.originalResponse.travelerPricings));
    pricingArray.forEach((ele: any, index: number) => {

      pricingArray[index].collapsed = false;
      pricingArray[index].isTravelerCollapsed = false;
      pricingArray[index].showPrice = false;
      let travelerType = ele.travelerType;
      if (travelerType == 'HELD_INFANT') {
        travelerType = 'INFANT';
      }
      pricingArray[index].travelerType = travelerType.toLowerCase()
      //get tax total
      let taxSum = 0;
      /*ele.price.taxes.forEach((tax: any, taxIndex: number) => {
        taxSum += parseInt(tax.amount)
      });*/

      pricingArray[index].price.totalTax = taxSum;

    });

    this.flightPriceByTraveller = pricingArray;
    this.setTravelerObject(pricingArray);

    //get loggedin customer traveler list
    if (this.global.isUserLogin) {

      this._customerService.getTravellerList().subscribe(response => {
        // this.customerTraveler = response.data.data;
        response.data.data.forEach((element: any, index: number) => {
          let tmpTraveler = element;
          tmpTraveler.title = this.TitleCasePipe.transform(element.title);
          tmpTraveler.isCollapsed = false;
          tmpTraveler.type = this.setTravelerType(element.date_of_birth);
          this.customerTraveler.push(tmpTraveler);
        });
      }, (error: HttpErrorResponse) => {
        if (error.status == 401) {
          alert("Login session expired. Please login to continue.");
          this.openLoginModal();
        }
        // Handle error
        // Use if conditions to check error code, this depends on your api, how it sends error messages
      });
    }
  }

  setTravelerType(dob: string) {
    let type = "adule";
    var today = new Date();
    var birthDate = new Date(dob);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    if (age > 12) {
      type = "adult";
    } else if (age >= 2 && age <= 12) {
      type = "child";
    } else if (age < 2) {
      type = "infant";
    }

    return type;
  }

  createTravelerForm() {
    this.flightTraveler = this.formBuilder.group({
      travelersArray: new FormArray([])
    });
  }

  setTravelerObject(traveler: any) {
    traveler.forEach((ele: any, index: number) => {

      // let passenger = {
      //   id: ele.travelerId,
      //   type: ele.travelerType,
      //   title: 'Mr', //text
      //   firstName:'', //text
      //   middleName:'', //text
      //   lastName:'', //text
      //   dob:'', //date
      //   gender: '', //logical on base of title
      //   nationality: '', //dropdown country ISO Code 2
      //   documentType: 'PASSPORT', //hardcoded
      //   number: '', //text
      //   expireDate: '', //date
      //   birthPlace: '',  //text
      //   issuanceDate: '', //date
      //   issuanceCountry:'', //dropdown country ISO Code 2
      //   issuanceLocation:'', //text
      //   isCollapsed: true,
      //   collapsed:  (index == 0) ? false : true,
      //   isTravelerCollapsed:  (index == 0) ? false : true
      // }
      // this.travellersData.push(passenger);
      const newFormGroup = this.formBuilder.group({
        type: [ele.travelerType],
        title: ['Mr', []],
        firstName: ['', [Validators.required]],
        middleName: [''],
        lastName: ['', [Validators.required]],
        dob: ['', [Validators.required]], //date
        gender: [''], //logical on base of title
        nationality: ['', [Validators.required]], //dropdown country ISO Code 2
        documentType: [''], //hardcoded
        number: ['', [Validators.required]], //text
        expireDate: ['', [Validators.required]], //date
        birthPlace: ['', [Validators.required]],  //text
        issuanceDate: ['', [Validators.required]], //date
        issuanceCountry: ['', [Validators.required]], //dropdown country ISO Code 2
        issuanceLocation: ['', [Validators.required]], //text
        addFrequentFlyer: [''],
        addMealsAssistance: [''],
        isTravelerCollapsed: [true],
        isCollapsed: [true],
        selectedTravellerID: [''],
        isOpenNationality: [false],
        isOpen: [false],
        searchText: [''],
        isCountrySelectedNation: [false],
        selectedCountryNation: [''],
        selectedCountryCodeNation: [''],

        isCountrySelected: [false],
        selectedCountry: [''],
        selectedCountryCode: ['']
      });
      this.travelersArray.push(newFormGroup);
      this.GetCountryList('', index);
    });
  }

  GetCountryList(type: string = '', index: number) {

    var searchText = this.travelersArray.at(index).get('searchText')?.value;

    this.global.GetCountryList(searchText).then((countryCodes: any[]) => {
      if (type == '') {
        this.countryCodes = countryCodes;
        this.countryCodesNationality = countryCodes;
      }
      else if (type == 'country') {
        this.countryCodes = countryCodes;
      }
      else if (type == 'nationality') {
        this.countryCodesNationality = countryCodes;
      }

      if (type == '' || type == 'country') {
        if (!this.travelersArray.at(index).get('isCountrySelected')?.value && this.countryCodes.length > 0) {

          var country = this.countryCodes.find(item => item.iso_code === this.global.customerCountryCode);

          if (country) {
            this.travelersArray.at(index).get('selectedCountry')?.setValue(country.country_en);
            this.travelersArray.at(index).get('selectedCountryCode')?.setValue(country.iso_code);
            this.travelersArray.at(index).get('issuanceCountry')?.setValue(country.iso_code);
          }
          else {
            this.travelersArray.at(index).get('selectedCountry')?.setValue(this.countryCodes[0].country_en);
            this.travelersArray.at(index).get('selectedCountryCode')?.setValue(this.countryCodes[0].iso_code);
            this.travelersArray.at(index).get('issuanceCountry')?.setValue(this.countryCodes[0].iso_code);
          }
        }
      }
      if (type == '' || type == 'nationality') {
        if (!this.travelersArray.at(index).get('isCountrySelectedNation')?.value && this.countryCodesNationality.length > 0) {

          var country = this.countryCodesNationality.find(item => item.iso_code === this.global.customerCountryCode);

          if (country) {
            this.travelersArray.at(index).get('selectedCountryNation')?.setValue(country.country_en);
            this.travelersArray.at(index).get('selectedCountryCodeNation')?.setValue(country.iso_code);
            this.travelersArray.at(index).get('nationality')?.setValue(country.iso_code);
          }
          else {
            this.travelersArray.at(index).get('selectedCountryNation')?.setValue(this.countryCodes[0].country_en);
            this.travelersArray.at(index).get('selectedCountryCodeNation')?.setValue(this.countryCodes[0].iso_code);
            this.travelersArray.at(index).get('nationality')?.setValue(this.countryCodes[0].iso_code);
          }
        }
      }
    });
  }

  search(type: string, index: number) {
    this.GetCountryList(type, index);
  }

  countryCodeSelectNationality(code: any, index: number) {

    this.travelersArray.at(index).get('isOpenNationality')?.setValue(false); // Close the dropdown when an option is selected
    this.travelersArray.at(index).get('searchText')?.setValue('');
    this.travelersArray.at(index).get('isCountrySelectedNation')?.setValue(true);
    this.travelersArray.at(index).get('selectedCountryNation')?.setValue(code.country_en);
    this.travelersArray.at(index).get('selectedCountryCodeNation')?.setValue(code.iso_code);
    this.travelersArray.at(index).get('nationality')?.setValue(code.iso_code);
    this.GetCountryList('', index);
  }

  countryCodeSelect(code: any, index: number) {

    this.travelersArray.at(index).get('isOpen')?.setValue(false); // Close the dropdown when an option is selected
    this.travelersArray.at(index).get('searchText')?.setValue('');
    this.travelersArray.at(index).get('isCountrySelected')?.setValue(true);
    this.travelersArray.at(index).get('selectedCountry')?.setValue(code.country_en);
    this.travelersArray.at(index).get('selectedCountryCode')?.setValue(code.iso_code);
    this.travelersArray.at(index).get('issuanceCountry')?.setValue(code.iso_code);
    this.GetCountryList('', index);
  }

  toggleDropdownNationality(index: number, event: Event) {
    event.stopPropagation(); // Prevent the click event from reaching parent elements

    var value = this.travelersArray.at(index).get('isOpenNationality')?.value;
    this.travelersArray.at(index).get('isOpenNationality')?.setValue(!value);
    this.travelersArray.at(index).get('isOpen')?.setValue(false);
  }

  toggleDropdown(index: number, event: Event) {
    event.stopPropagation(); // Prevent the click event from reaching parent elements

    var value = this.travelersArray.at(index).get('isOpen')?.value;
    this.travelersArray.at(index).get('isOpen')?.setValue(!value);
    this.travelersArray.at(index).get('isOpenNationality')?.setValue(false);
  }

  // get f(): { [key: string]: AbstractControl } {
  //   return this.flightTraveler.controls;
  // }

  // get fs() { return this.flightTraveler.controls; }
  // get m() { return this.fs['travelers'] as FormArray; }
  // get travelerGroups() { return this.m.controls as FormGroup[]; }
  get travelersArray(): FormArray {
    return this.flightTraveler.get('travelersArray') as FormArray;
  }

  submitTravellers() {
    this.submitted = true;

    if (this.flightTraveler.invalid) {
      console.log('Form is invalid. Please check the fields.');
    } else {
      // Perform any additional actions or submit the form
      this.toggleFlightSeatBooking();
    }
  }

  onSubmit() {
    this.submitted = true; // Set a flag to indicate that the form has been submitted    
  }


  toggleTravelerPrice(traveler: Traveler): void {
    traveler.showPrice = !traveler.showPrice;
  }

  savedTravelers: SavedTraveler[] = [
    { id: 1, firstname: 'Abdelslam', lastname: 'Aly', dob: '01/01/1980', nationality: 'USA', passport: '123456789', expiry: '01/01/2025', issueCountry: 'USA' },
    { id: 2, firstname: 'Somya', lastname: 'Martand', dob: '02/02/1990', nationality: 'India', passport: '987654321', expiry: '02/02/2026', issueCountry: 'India' },
    // Add more saved travelers as needed
  ];

  toggleCollapse(index: number) {
    var value = this.travelersArray.at(index).get('isCollapsed')?.value;
    this.travelersArray.at(index).get('isCollapsed')?.setValue(!value);
  }

  toggleTravelerCollapse(index: number) {
    var value = this.travelersArray.at(index).get('isTravelerCollapsed')?.value;
    this.travelersArray.at(index).get('isTravelerCollapsed')?.setValue(!value);
  }

  isSavedTravelerSelectedForOtherTravelers(index: number, savedTraveler: SavedTraveler) {
    let Id = savedTraveler.id;
    if (Id) {
      const otherTravelers = this.travelersArray.controls.filter((control, i) => i !== index);

      // Check if any other traveler has the same selectedTravellerID
      var res = otherTravelers.some(control => control.value.selectedTravellerID === Id);
      if (!res)
        return null;
      else
        return res;
    }
    return false;
  }

  selectSavedTraveler(index: number, savedTraveler: any) {
    if (!this.isSavedTravelerSelectedForOtherTravelers(index, savedTraveler)) {
      this.travelersArray.at(index).get('selectedTravellerID')?.setValue(savedTraveler.id);
      this.travelersArray.at(index).get('title')?.setValue(savedTraveler.title);
      this.travelersArray.at(index).get('firstName')?.setValue(savedTraveler.first_name);
      this.travelersArray.at(index).get('lastName')?.setValue(savedTraveler.last_name);
      this.travelersArray.at(index).get('middleName')?.setValue(savedTraveler.second_name);
      this.travelersArray.at(index).get('dob')?.setValue(savedTraveler.date_of_birth);
      this.travelersArray.at(index).get('nationality')?.setValue(savedTraveler.nationality_id);
      this.travelersArray.at(index).get('number')?.setValue(savedTraveler.id_number);
      this.travelersArray.at(index).get('issuanceDate')?.setValue(savedTraveler.issue_date);
      this.travelersArray.at(index).get('expireDate')?.setValue(savedTraveler.expiry_date);
      this.travelersArray.at(index).get('issuanceLocation')?.setValue(savedTraveler.get_country.iso_code);
      this.travelersArray.at(index).get('issuanceCountry')?.setValue(savedTraveler.get_country.iso_code);
    }
  }

  resetSelection(index: number) {
    this.travelersArray.at(index).get('selectedTravellerID')?.setValue('');
    this.travelersArray.at(index).get('title')?.setValue('');
    this.travelersArray.at(index).get('firstName')?.setValue('');
    this.travelersArray.at(index).get('lastName')?.setValue('');
    this.travelersArray.at(index).get('middleName')?.setValue('');
    this.travelersArray.at(index).get('dob')?.setValue('');
    this.travelersArray.at(index).get('nationality')?.setValue('');
    this.travelersArray.at(index).get('number')?.setValue('');
    this.travelersArray.at(index).get('issuanceDate')?.setValue('');
    this.travelersArray.at(index).get('expireDate')?.setValue('');
    this.travelersArray.at(index).get('issuanceLocation')?.setValue('');
    this.travelersArray.at(index).get('issuanceCountry')?.setValue('');
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config);
  }

  hideFlightBookingDetail(): void {
    this.close.emit();
  }

  openLoginModal() {

    this.modalRef = this.modalService.show(CustomModalComponent, this.config);
    this.modalRef.onHide.subscribe((reason: string | any) => {
      if (reason === 'backdrop-click') {

      }
    });
  };

  toggleFlightSeatBooking() {
    this.showFlightSeatBooking = !this.showFlightSeatBooking;
    this.showFirstPop = !this.showFlightSeatBooking;
  }

  goBackFromSeatBooking() {
    this.showFlightSeatBooking = false;
    this.showFlightBookingDetail = true;
    this.showFirstPop = true;
  }

  goBackFromPayment() {
    this.showFlightPayment = false;
    this.showFlightSeatBooking = true;
  }

  closeSeatBooking() {
    this.showFlightSeatBooking = false;
  }

  closePaymentBooking() {
    this.showFlightPayment = false;
  }

  skipSeatSelection() {
    this.showFlightSeatBooking = false;
    this.showFlightPayment = true;
  }
}
